import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_PERSONALIZATION_PENDING,
  GET_PERSONALIZATION_FAILED,
  GET_PERSONALIZATION_FULFILLED,
} from "constants-lib/actionTypes"

export const getPersonalizationPending = () => ({
  type: GET_PERSONALIZATION_PENDING,
})

export const getPersonalizationFailed = (error) => ({
  type: GET_PERSONALIZATION_FAILED,
  payload: error,
})

export const getPersonalizationFulfilled = (type, data) => ({
  type,
  payload: data,
})

export const getPersonalization = (gisId) => async (dispatch, getState) => {
  dispatch(getPersonalizationPending())
  const api = `GET_PERSONALIZATION`
  const apiKey = get(urls, `apiKey.GUEST.GET_PERSONALIZATION`, ``)

  const template = URITemplate(urls.url[api])
  const state = getState()
  const locale = get(state, `siteLanguage.language`, ``)

  const url = template.expand({
    gisId,
    lang: locale,
  })

  const config = {
    headers: {
      apiKey,
    },
  }
  try {
    const response = await axios.create(config).get(url)
    const responseData = get(response, `data`, {})

    dispatch(
      getPersonalizationFulfilled(GET_PERSONALIZATION_FULFILLED, responseData),
    )
    return responseData
  } catch (error) {
    dispatch(getPersonalizationFailed(error))
    return null
  }
}
